import React from 'react';

import { IToolbarPluginRenderProps, Strategy } from '../../types';
import { getEntityStrategyByType } from '../../utilities';

import LinkButton from './LinkButton';
import LinkDecorator from './LinkDecorator';

const linkPlugin = () => {
  const DecoratedLinkButton = (props: IToolbarPluginRenderProps) => {
    return <LinkButton {...props} />;
  };

  return {
    decorators: [
      {
        strategy: (...args: Strategy) => getEntityStrategyByType('LINK', ...args),
        component: LinkDecorator,
      },
    ],
    LinkButton: DecoratedLinkButton,
  };
};

export default linkPlugin;
